import { Injectable, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PhotoGalleryService {
  openImageGallery = false;
  imageObservable = new BehaviorSubject([]);
  showThumbnailsObservable = new BehaviorSubject([]);
  slideIdObservable = new BehaviorSubject([]);
  images = this.imageObservable.asObservable();
  showThumbnails = this.showThumbnailsObservable.asObservable();
  slideId = this.slideIdObservable.asObservable();
  previewImage;

  @Output()
  update: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  toggle() {
    this.openImageGallery = !this.openImageGallery;
    this.update.emit(this.openImageGallery);
  }

  setImages(images) {
    this.imageObservable.next(images);
  }

  setShowThumbnails(toShow) {
    this.showThumbnailsObservable.next(toShow);
  }

  selectedImage(id) {
    this.slideIdObservable.next(id);
  }
}
